import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import { CalendarFilter } from "@/types";
import { LoginUser } from "@/types/Component";

Vue.use(Vuex)

interface State {
    accsessToken: string;
    loginUser: LoginUser;
    tenantId: string;
    currentPage: string;
    parentPage: string;
    calendarFilter: CalendarFilter;
    isTenantChanged:boolean;
    notificationCount:string;
    deleteTenantAlertPopUp :boolean
}

const store = new Vuex.Store({

    state: {
        accsessToken: null,
        loginUser: null,
        tenantId: null,
        currentPageName: null,
        parentPageName: null,
        parentPageNames: [],
        calendarFilter: null,
        isInputChanged: false,
        isTenantChanged:false,
        notificationCount:null,
        deleteTenantAlertPopUp:false
    },

    getters: {
        accsessToken(state) {
            return state.accsessToken
        },
        loginUser(state) {
            return state.loginUser
        },
        tenantId(state) {
            return state.tenantId
        },
        currentPageName(state) {
            return state.currentPageName
        },
        parentPageName(state) {
            return state.parentPageName
        },
        parentPageNames(state) {
            return state.parentPageNames
        },
        calendarFilter(state) {
            return state.calendarFilter
        },
        isInputChanged(state) {
            return state.isInputChanged
        },
        isTenantChanged(state){
            return state.isTenantChanged
        },
        notificationCount(state){
            return state.notificationCount
        },
        deleteTenantAlertPopUp(state){
            return state.deleteTenantAlertPopUp
        }
    },

    mutations: {
        setAccsessToken(state, payload) {
            state.accsessToken = payload.accsessToken
        },
        updateLoginUser(state, payload) {
            state.loginUser = payload.loginUser
        },
        setLastTenantId(state, payload) {
            state.tenantId = payload.tenantId
        },
        setCurrentPageName(state, payload) {
            state.currentPageName = payload.currentPageName
        },
        setParentPageName(state, payload) {
            state.parentPageName = payload.parentPageName
        },
        setParentPageNames(state, payload) {
            state.parentPageNames = payload.parentPageNames
        },
        setCalendarFilter(state, payload) {
            state.calendarFilter = payload.calendarFilter
        },
        setIsInputChanged(state, payload) {
            state.isInputChanged = payload.isInputChanged
        },
        setIsTenantChanged(state, payload){
            state.isTenantChanged = payload.isTenantChanged
        },
        setNotificationCount(state,payload){
            state.notificationCount = payload.notificationCount
        },
        setDeleteTenantAlertPopUp(state,payload){
            state.deleteTenantAlertPopUp = payload.deleteTenantAlertPopUp
        }
    },

    actions: {
        doUpdateSession({ commit }, accsessToken) {
            commit('setAccsessToken', { accsessToken })
        },
        doUpdateLoginUser({ commit }, loginUser) {
            commit('updateLoginUser', { loginUser })
        },
        doUpdateLastTenantId({ commit }, tenantId) {
            commit('setLastTenantId', { tenantId })
        },
        doUpdateCurrentPageName({ commit }, currentPageName) {
            commit('setCurrentPageName', { currentPageName })
        },
        doUpdateParentPageName({ commit }, parentPageName) {
            commit('setParentPageName', { parentPageName })
        },
        doUpdateParentPageNames({ commit }, parentPageNames) {
            commit('setParentPageNames', { parentPageNames })
        },
        doUpdateCalendarFilter({ commit }, calendarFilter) {
            commit('setCalendarFilter', { calendarFilter })
        },
        doUpdateIsInputChanged({ commit }, isInputChanged) {
            commit('setIsInputChanged', { isInputChanged })
        },
        doUpdateIsTenantChanged({ commit },isTenantChanged){
            commit('setIsTenantChanged',{ isTenantChanged })
        },
        doUpdateNotificationCount({commit},notificationCount){
            commit('setNotificationCount',{notificationCount})
        },
        doUpdateDeleteTenantAlertPopUp({commit},deleteTenantAlertPopUp){
            commit('setDeleteTenantAlertPopUp',{deleteTenantAlertPopUp})
        }        
    },

    plugins: [createPersistedState({ storage: window.sessionStorage })]
})
export default store
